import * as CrosstabConstants from './constants';

/*
 * Action to set the currently active tab id in the store
 * @returns {Object} - action
 */
export function setCurrentlyPlayingTabId(tabId) {
  return {
    type: CrosstabConstants.CrossTabActions.SET_XTAB_CURRENTLY_PLAYING_TAB_ID,
    data: {
      tabId,
    },
  };
}

/**
 * Action to set this tab's tabId in the store
 *
 * @returns {object} - action
 */
export function setMyTabId() {
  const tabId = Math.random().toString(); // This window's randomly generated Id

  return {
    type: CrosstabConstants.CrossTabActions.SET_XTAB_MY_TAB_ID,
    data: {
      tabId,
    },
  };
}
